export const NATIONALITY = 'nationality'
export const DESTINATION = 'destination'
export const NATIONALITY_TITLE = 'Your Citizenship'
export const NATIONALITY_DROPDOWN_PLACEHOLDER = 'Select your nationality'
export const DESTINATION_TITLE = 'Travel Details'
export const DESTINATION_DROPDOWN_PLACEHOLDER = 'Select destination'
export const nationalityList = [
    { key: 'AF', item: 'Afghanistan' },
    { key: 'AX', item: 'Aland Islands' },
    { key: 'AL', item: 'Albania' },
    { key: 'DZ', item: 'Algeria' },
    { key: 'AS', item: 'American Samoa' },
    { key: 'AD', item: 'Andorra' },
    { key: 'AO', item: 'Angola' },
    { key: 'AI', item: 'Anguilla' },
    { key: 'AQ', item: 'Antarctica' },
    { key: 'AG', item: 'Antigua And Barbuda' },
    { key: 'AR', item: 'Argentina' },
    { key: 'AM', item: 'Armenia' },
    { key: 'AW', item: 'Aruba' },
    { key: 'AU', item: 'Australia' },
    { key: 'AT', item: 'Austria' },
    { key: 'AZ', item: 'Azerbaijan' },
    { key: 'BS', item: 'Bahamas' },
    { key: 'BH', item: 'Bahrain' },
    { key: 'BD', item: 'Bangladesh' },
    { key: 'BB', item: 'Barbados' },
    { key: 'BY', item: 'Belarus' },
    { key: 'BE', item: 'Belgium' },
    { key: 'BZ', item: 'Belize' },
    { key: 'BJ', item: 'Benin' },
    { key: 'BM', item: 'Bermuda' },
    { key: 'BT', item: 'Bhutan' },
    { key: 'BO', item: 'Bolivia' },
    { key: 'BA', item: 'Bosnia And Herzegovina' },
    { key: 'BW', item: 'Botswana' },
    { key: 'BV', item: 'Bouvet Island' },
    { key: 'BR', item: 'Brazil' },
    { key: 'IO', item: 'British Indian Ocean Territory' },
    { key: 'VG', item: 'British Virgin Islands' },
    { key: 'BN', item: 'Brunei Darussalam' },
    { key: 'BG', item: 'Bulgaria' },
    { key: 'BF', item: 'Burkina Faso' },
    { key: 'BI', item: 'Burundi' },
    { key: 'KH', item: 'Cambodia' },
    { key: 'CM', item: 'Cameroon' },
    { key: 'CA', item: 'Canada' },
    { key: 'CV', item: 'Cape Verde' },
    { key: 'KY', item: 'Cayman Islands' },
    { key: 'CF', item: 'Central African Republic' },
    { key: 'TD', item: 'Chad' },
    { key: 'CL', item: 'Chile' },
    { key: 'CN', item: 'China' },
    { key: 'CX', item: 'Christmas Island' },
    { key: 'CC', item: 'Cocos Islands' },
    { key: 'CO', item: 'Colombia' },
    { key: 'KM', item: 'Comoros' },
    { key: 'CG', item: 'Congo' },
    { key: 'CD', item: 'Congo, The Democratic Republic Of The' },
    { key: 'CK', item: 'Cook Islands' },
    { key: 'CR', item: 'Costa Rica' },
    { key: 'CI', item: "Cote D'ivoire" },
    { key: 'HR', item: 'Croatia' },
    { key: 'CU', item: 'Cuba' },
    { key: 'CY', item: 'Cyprus' },
    { key: 'CZ', item: 'Czech Republic' },
    { key: 'DK', item: 'Denmark' },
    { key: 'DJ', item: 'Djibouti' },
    { key: 'DM', item: 'Dominica' },
    { key: 'DO', item: 'Dominican Republic' },
    { key: 'EC', item: 'Ecuador' },
    { key: 'EG', item: 'Egypt' },
    { key: 'SV', item: 'El Salvador' },
    { key: 'GQ', item: 'Equatorial Guinea' },
    { key: 'ER', item: 'Eritrea' },
    { key: 'EE', item: 'Estonia' },
    { key: 'ET', item: 'Ethiopia' },
    { key: 'FK', item: 'Falkland Islands' },
    { key: 'FO', item: 'Faroe Islands' },
    { key: 'FJ', item: 'Fiji' },
    { key: 'FI', item: 'Finland' },
    { key: 'FR', item: 'France' },
    { key: 'GF', item: 'French Guiana' },
    { key: 'PF', item: 'French Polynesia' },
    { key: 'TF', item: 'French Southern Territories' },
    { key: 'GA', item: 'Gabon' },
    { key: 'GM', item: 'Gambia' },
    { key: 'GE', item: 'Georgia' },
    { key: 'DE', item: 'Germany' },
    { key: 'GH', item: 'Ghana' },
    { key: 'GI', item: 'Gibraltar' },
    { key: 'GR', item: 'Greece' },
    { key: 'GL', item: 'Greenland' },
    { key: 'GD', item: 'Grenada' },
    { key: 'GP', item: 'Guadeloupe' },
    { key: 'GU', item: 'Guam' },
    { key: 'GT', item: 'Guatemala' },
    { key: 'GG', item: 'Guernsey' },
    { key: 'GN', item: 'Guinea' },
    { key: 'GW', item: 'Guinea-Bissau' },
    { key: 'GY', item: 'Guyana' },
    { key: 'HT', item: 'Haiti' },
    { key: 'HM', item: 'Heard Island And Mcdonald Islands' },
    { key: 'HN', item: 'Honduras' },
    { key: 'HK', item: 'Hong Kong' },
    { key: 'HU', item: 'Hungary' },
    { key: 'IS', item: 'Iceland' },
    { key: 'IN', item: 'India' },
    { key: 'ID', item: 'Indonesia' },
    { key: 'IR', item: 'Iran' },
    { key: 'IQ', item: 'Iraq' },
    { key: 'IE', item: 'Ireland' },
    { key: 'IM', item: 'Isle Of Man' },
    { key: 'IL', item: 'Israel' },
    { key: 'IT', item: 'Italy' },
    { key: 'JM', item: 'Jamaica' },
    { key: 'JP', item: 'Japan' },
    { key: 'JE', item: 'Jersey' },
    { key: 'JO', item: 'Jordan' },
    { key: 'KZ', item: 'Kazakhstan' },
    { key: 'KE', item: 'Kenya' },
    { key: 'KI', item: 'Kiribati' },
    { key: 'KP', item: "Korea, Democratic People's Republic Of" },
    { key: 'KR', item: 'Korea, Republic Of' },
    { key: 'XK', item: 'Kosovo' },
    { key: 'KW', item: 'Kuwait' },
    { key: 'KG', item: 'Kyrgyzstan' },
    { key: 'LA', item: 'Laos' },
    { key: 'LV', item: 'Latvia' },
    { key: 'LB', item: 'Lebanon' },
    { key: 'LS', item: 'Lesotho' },
    { key: 'LR', item: 'Liberia' },
    { key: 'LY', item: 'Libyan Arab Jamahiriya' },
    { key: 'LI', item: 'Liechtenstein' },
    { key: 'LT', item: 'Lithuania' },
    { key: 'LU', item: 'Luxembourg' },
    { key: 'MO', item: 'Macao' },
    { key: 'MK', item: 'Macedonia, The Former Yugoslav Republic Of' },
    { key: 'MG', item: 'Madagascar' },
    { key: 'MW', item: 'Malawi' },
    { key: 'MY', item: 'Malaysia' },
    { key: 'MV', item: 'Maldives' },
    { key: 'ML', item: 'Mali' },
    { key: 'MT', item: 'Malta' },
    { key: 'MH', item: 'Marshall Islands' },
    { key: 'MQ', item: 'Martinique' },
    { key: 'MR', item: 'Mauritania' },
    { key: 'MU', item: 'Mauritius' },
    { key: 'YT', item: 'Mayotte' },
    { key: 'MX', item: 'Mexico' },
    { key: 'FM', item: 'Micronesia, Federated States Of' },
    { key: 'MD', item: 'Moldova, Republic Of' },
    { key: 'MC', item: 'Monaco' },
    { key: 'MN', item: 'Mongolia' },
    { key: 'ME', item: 'Montenegro' },
    { key: 'MS', item: 'Montserrat' },
    { key: 'MA', item: 'Morocco' },
    { key: 'MZ', item: 'Mozambique' },
    { key: 'MM', item: 'Myanmar' },
    { key: 'NA', item: 'Namibia' },
    { key: 'NR', item: 'Nauru' },
    { key: 'NP', item: 'Nepal' },
    { key: 'NL', item: 'Netherlands' },
    { key: 'AN', item: 'Netherlands Antilles' },
    { key: 'NC', item: 'New Caledonia' },
    { key: 'NZ', item: 'New Zealand' },
    { key: 'NI', item: 'Nicaragua' },
    { key: 'NE', item: 'Niger' },
    { key: 'NG', item: 'Nigeria' },
    { key: 'NU', item: 'Niue' },
    { key: 'NF', item: 'Norfolk Island' },
    { key: 'MP', item: 'Northern Mariana Islands' },
    { key: 'NO', item: 'Norway' },
    { key: 'OM', item: 'Oman' },
    { key: 'PK', item: 'Pakistan' },
    { key: 'PW', item: 'Palau' },
    { key: 'PS', item: 'Palestinian Territory, Occupied' },
    { key: 'PA', item: 'Panama' },
    { key: 'PG', item: 'Papua New Guinea' },
    { key: 'PY', item: 'Paraguay' },
    { key: 'PE', item: 'Peru' },
    { key: 'PH', item: 'Philippines' },
    { key: 'PN', item: 'Pitcairn' },
    { key: 'PL', item: 'Poland' },
    { key: 'PT', item: 'Portugal' },
    { key: 'PR', item: 'Puerto Rico' },
    { key: 'QA', item: 'Qatar' },
    { key: 'RE', item: 'Reunion' },
    { key: 'RO', item: 'Romania' },
    { key: 'RU', item: 'Russian Federation' },
    { key: 'RW', item: 'Rwanda' },
    { key: 'BL', item: 'Saint BarthTlemy' },
    { key: 'SH', item: 'Saint Helena' },
    { key: 'KN', item: 'Saint Kitts And Nevis' },
    { key: 'LC', item: 'Saint Lucia' },
    { key: 'MF', item: 'Saint Martin' },
    { key: 'PM', item: 'Saint Pierre And Miquelon' },
    { key: 'VC', item: 'Saint Vincent And The Grenadines' },
    { key: 'WS', item: 'Samoa' },
    { key: 'SM', item: 'San Marino' },
    { key: 'ST', item: 'Sao Tome And Principe' },
    { key: 'SA', item: 'Saudi Arabia' },
    { key: 'SN', item: 'Senegal' },
    { key: 'RS', item: 'Serbia' },
    { key: 'SC', item: 'Seychelles' },
    { key: 'SL', item: 'Sierra Leone' },
    { key: 'SG', item: 'Singapore' },
    { key: 'SK', item: 'Slovakia' },
    { key: 'SI', item: 'Slovenia' },
    { key: 'SB', item: 'Solomon Islands' },
    { key: 'SO', item: 'Somalia' },
    { key: 'ZA', item: 'South Africa' },
    { key: 'GS', item: 'South Georgia And The South Sandwich Islands' },
    { key: 'SS', item: 'South Sudan' },
    { key: 'ES', item: 'Spain' },
    { key: 'LK', item: 'Sri Lanka' },
    { key: 'SD', item: 'Sudan' },
    { key: 'SR', item: 'Suriname' },
    { key: 'SJ', item: 'Svalbard And Jan Mayen' },
    { key: 'SZ', item: 'Swaziland' },
    { key: 'SE', item: 'Sweden' },
    { key: 'CH', item: 'Switzerland' },
    { key: 'SY', item: 'Syrian Arab Republic' },
    { key: 'TW', item: 'Taiwan, Province Of China' },
    { key: 'TJ', item: 'Tajikistan' },
    { key: 'TZ', item: 'Tanzania, United Republic Of' },
    { key: 'TH', item: 'Thailand' },
    { key: 'TL', item: 'Timor-Leste' },
    { key: 'TG', item: 'Togo' },
    { key: 'TK', item: 'Tokelau' },
    { key: 'TO', item: 'Tonga' },
    { key: 'TT', item: 'Trinidad And Tobago' },
    { key: 'TN', item: 'Tunisia' },
    { key: 'TR', item: 'Turkey' },
    { key: 'TM', item: 'Turkmenistan' },
    { key: 'TC', item: 'Turks And Caicos Islands' },
    { key: 'TV', item: 'Tuvalu' },
    { key: 'VI', item: 'U.S. Virgin Islands' },
    { key: 'UG', item: 'Uganda' },
    { key: 'UA', item: 'Ukraine' },
    { key: 'AE', item: 'United Arab Emirates' },
    { key: 'GB', item: 'United Kingdom' },
    { key: 'US', item: 'United States' },
    { key: 'UM', item: 'United States Minor Outlying Islands' },
    { key: 'UY', item: 'Uruguay' },
    { key: 'UZ', item: 'Uzbekistan' },
    { key: 'VU', item: 'Vanuatu' },
    { key: 'VA', item: 'Vatican City' },
    { key: 'VE', item: 'Venezuela' },
    { key: 'VN', item: 'Vietnam' },
    { key: 'WF', item: 'Wallis And Futuna' },
    { key: 'EH', item: 'Western Sahara' },
    { key: 'YE', item: 'Yemen' },
    { key: 'ZM', item: 'Zambia' },
    { key: 'ZW', item: 'Zimbabwe' }
]

export const travelDetailsList = [
    {
        key: 'AE',
        item: 'United Arab Emirates'
    }
]
